import '../../../Dialogs/View/ViewOrderDialog.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import useMediaQuery from '../../../../../../hooks/useMediaQuery';
import DialogSpinner from '../../../../../Dialogs/DialogSpinner/DialogSpinner';
import { IncompleteOrders } from '../../Incomplete.functions';
import ViewIncompleteContentDialog from './ViewOrderContent';

type Props = {
  visible: boolean;
  data: IncompleteOrders | undefined;
  onEdit?: () => void;
  onHide: () => void;
};

function ViewIncompleteOrderDialog({ visible, data, onEdit, onHide }: Props) {
  const { t } = useTranslation();

  const dialogFooter = (
    <>
      {onEdit && (
        <Button label={t('Edit')} className="p-button-text" onClick={onEdit} />
      )}
      <Button label={t('Close')} onClick={() => onHide()} />
    </>
  );

  const isOnMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('Order {{serialNo}}', {
        serialNo: data?.orderSerialNumber ?? '',
      })}
      footer={dialogFooter}
      dismissableMask
      blockScroll
      maximizable
      maximized={isOnMobile}
      className="view-order-dialog"
    >
      {false ? <DialogSpinner /> : <ViewIncompleteContentDialog data={data} />}
    </Dialog>
  );
}

export default ViewIncompleteOrderDialog;
